<template>
  <div id="excel_wrapper">
    <div id="contract_table_wrap">
      <component :is="currentView"
        :campaignType="campaignType"
        :contractData="contractData.contract"
        :parseDataType="parseDataType"
        :contractTotal="contractTotal"
        id="contractTable"></component>
      <div v-if="!isInterPlay">
        <table id='contractDaysTable'>
          <DaysImp
            :checkDate="checkDate"
            :headers="headers"
            :isCreative="isCreative"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="contract"></DaysImp>
          <DaysTotal
            :checkDate="checkDate"
            :dataInfo="contractData.contract"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="contract">
          </DaysTotal>
        </table>
        <template v-for="(data, n) in contractData.contract">
          <ContentImp
            :headers="headers"
            :isExcel="isExcel"
            :num="n"
            tab="contract"
            :key="n">
          </ContentImp>
        </template>
      </div>
      <template v-if="isInterPlay">
        <InterPlayAdBottom
          :campaignType="campaignType"
          :getViewDataList="getViewDataList"
          adNm="total"
          :isExcel="isExcel">
        </InterPlayAdBottom>
        <InterPlayAdBottom v-for="(data, n) in contractData.contract"
          :campaignData="contractData.contract"
          :getViewDataList="getViewDataList"
          :campaignType="campaignType"
          :checkDate="checkDate"
          :adNm="data.ad_knd_nm"
          :num="n"
          :isExcel="isExcel"
          :key="n+'_'+campaignType">
        </InterPlayAdBottom>
      </template>
    </div>
    <div id="size_table_wrap">
      <SizeTable
        checkRadio="all"
        :viewData="sizeData.size"
        id="sizeTable">
      </SizeTable>
      <table id='sizeDaysTable'>
        <DaysImp
          :checkDate="checkDate"
          :headers="headers"
          :isCreative="isCreative"
          :isInterPlay="isInterPlay"
          :isExcel="isExcel"
          tab="size"></DaysImp>
        <DaysTotal
          :checkDate="checkDate"
          :adInfo="contractData.contract"
          :dataInfo="sizeData.size"
          :isExcel="isExcel"
          tab="size">
        </DaysTotal>
      </table>
      <template v-for="(data, n) in sizeData.size">
        <ContentImp
          :headers="headers"
          :isExcel="isExcel"
          :num="n"
          tab="size"
          :key="n">
        </ContentImp>
      </template>
    </div>
    <div id="creative_table_wrap">
      <CreativeTable
        :viewData="creativeData.creative"
        :campaignType="campaignType"
        :isExcel="isExcel"
        id="creativeTable">
      </CreativeTable>
      <div v-if="!isInterPlay">
        <table id='creativeDaysTable'>
          <DaysImp
            :checkDate="checkDate"
            :headers="headers"
            :isCreative="isCreative"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="creative"></DaysImp>
          <DaysTotal
            :checkDate="checkDate"
            :dataInfo="creativeData.creative"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="creative">
          </DaysTotal>
        </table>
        <template v-for="(data, n) in creativeData.creative">
          <ContentImp
            :headers="headers"
            :isExcel="isExcel"
            :num="n"
            tab="creative"
            :key="n">
          </ContentImp>
        </template>
      </div>
      <template v-if="isInterPlay">
        <InterPlayCrBottom v-for="(data, n) in creativeData.creative"
          :campaignData="creativeData.creative"
          :campaginDaysData="creativeData.creativeAndDate"
          :campaignType="campaignType"
          :checkDate="checkDate"
          :crNm="data"
          :num="n"
          :isExcel="isExcel"
          :key="n, campaignType">
        </InterPlayCrBottom>
      </template>
    </div>
    <div id="creativeGroup_table_wrap">
      <CgTable
        :viewData="creativeGroupData.creativeGroup"
        :campaignType="campaignType"
        :isExcel="isExcel"
        id="creativeGroupTable">
      </CgTable>
        <table id='creativeGroupDaysTable'>
            <DaysImp
            :checkDate="checkDate"
            :headers="headers"
            :isCreative="isCreative"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="creativeGroup"></DaysImp>
            <DaysTotal
            :checkDate="checkDate"
            :dataInfo="creativeGroupData.creativeGroup"
            :isInterPlay="isInterPlay"
            :isExcel="isExcel"
            tab="creativeGroup">
            </DaysTotal>
        </table>
        <template v-for="(data, n) in creativeGroupData.creativeGroup">
            <ContentImp
            :headers="headers"
            :isExcel="isExcel"
            :num="n"
            tab="creativeGroup"
            :key="n">
            </ContentImp>
        </template>
    </div>
    <div id="geo_table_wrap">
      <GeoTable
        checkRadio="all"
        :viewData="geoData.geo"
        id="geoTable">
      </GeoTable>
      <table id='geoDaysTable'>
        <DaysImp
          :checkDate="checkDate"
          :headers="headers"
          :isCreative="isCreative"
          :isInterPlay="isInterPlay"
          :isExcel="isExcel"
          tab="geo"></DaysImp>
        <DaysTotal
          :checkDate="checkDate"
          :adInfo="contractData.contract"
          :dataInfo="geoData.geo"
          :isExcel="isExcel"
          tab="geo">
        </DaysTotal>
      </table>
      <template v-for="(data, n) in geoData.geo">
        <ContentImp
          :headers="headers"
          :isExcel="isExcel"
          :num="n"
          tab="geo"
          :key="n">
        </ContentImp>
      </template>
    </div>
    <div id="temp_table">
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {parseDataType, getContractTotal, isInterPlay, currentIPView} from '@/assets/func'

  import ContractBaseTable from '@/components/campaign/contract/ContractBaseTable'
  import ContractInterPlay from '@/components/campaign/contract/ContractInterPlay'
  import ContractInterPlayCV from '@/components/campaign/contract/ContractInterPlayCV'
  import ContractInterPlayCPCV from '@/components/campaign/contract/ContractInterPlayCPCV'
  import SizeTable from '@/components/campaign/size/SizeTable'
  import GeoTable from '@/components/campaign/geo/GeoTable'
  import CreativeTable from '@/components/campaign/creative/CreativeTable'
  import InterPlayAdBottom from '@/components/campaign/campaignBotTable/InterPlayAdBottom'
  import DaysImp from '@/components/campaign/campaignBotTable/DaysImp'
  import DaysTotal from '@/components/campaign/campaignBotTable/DaysTotal'
  import ContentImp from '@/components/campaign/campaignBotTable/ContentImp'
  import InterPlayCrBottom from '@/components/campaign/campaignBotTable/InterPlayCrBottom'
  import CgTable from '../creativeGroup/CgTable.vue'

  export default {
    name: 'name',
    props: {
      campaignType: String,
      checkDate: Function
    },
    data () {
      return {
        isExcel: true,
        headers: [
          '노출수',
          '클릭수',
          'CTR(%)',
          '일광고비'
        ],
        isCreative: false
      }
    },
    components: {
      ContractBaseTable,
      ContractInterPlay,
      ContractInterPlayCV,
      ContractInterPlayCPCV,
      SizeTable,
      GeoTable,
      CreativeTable,
      InterPlayAdBottom,
      DaysImp,
      DaysTotal,
      ContentImp,
      InterPlayCrBottom,
      CgTable
    },
    computed: {
      ...mapState({
        campaignInfo: state => state.campaign.campaignInfo,
        contractData: state => state.campaign.contractData,
        creativeData: state => state.campaign.creativeData,
        creativeGroupData: state => state.campaign.cgData,
        sizeData: state => state.campaign.sizeData,
        geoData: state => state.campaign.geoData
      }),
      contractTotal () {
        return getContractTotal(this.contractData.contract, this.campaignType, this.isInterPlay)
      },
      currentView () { // 일반 상품, 인터플레이 종류에따라 보여줄 컴포넌트 변경
        return currentIPView(this.campaignType)
      },
      isInterPlay () {
        return isInterPlay()
      }
    },
    methods: {
      ...mapGetters([
        'getInterPlayDaysData'
      ]),
      getViewDataList (selected) {
        return this.getInterPlayDaysData()(selected)
      },
      parseDataType (data) {
        return parseDataType(data)
      }
    }
  }
</script>

<style scoped>
  #excel_wrapper {
    display: none;
  }
  #temp_table {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// ExcelTable.vue?76e7a0ae